
import { getPaidInfo, getPaidList } from '@/api/task/withdraw'
import { AppModule } from '@/store/modules/app'
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import setPaidInfo from './setPaidInfo.vue'
import detail from './paidDetail.vue'
@Component({
  name: 'paidList',
  components: {
    setPaidInfo,
    detail
  }
})
export default class extends Vue {
  @Prop({ required: true }) ordernumber!: number
  @Prop({ required: true, default: [] }) orderList!: any[]
  private WithdrawList: any[] = []
  private orderStatusList: any[] = []
  private currentInfo: any = {}
  private dialogVisible: boolean = false
  private action: string = ''
  private openDialog (action: string, param: any) {
    this.action = action
    this.currentInfo = param
    this.currentInfo.status_display = this.orderStatusList[param.status].text
    this.dialogVisible = true
  }

  private hashJump (row) {
    window.open(`https://tronscan.io/#/transaction/${row.upstream_ordernumber}`)
  }

  private closeDialog (is: boolean) {
    this.dialogVisible = false
    this.currentInfo = null
    if (is) {
      this.getPaidList()
      this.$emit('refresh')
    }
  }

  private async getPaidInfo (ordernumber: string) {
    const data: any = {
      ordernumber: ordernumber
    }
    await getPaidInfo(data).then((res: any) => {
      this.$message({
        message: 'query successfully!',
        type: 'success'
      })
      this.getPaidList()
    })
  }

  private async getPaidList () {
    const data: any = {
      ordernumber: this.ordernumber
    }
    await getPaidList(data).then((res: any) => {
      this.WithdrawList = res
    })
  }

  private async init () {
    this.orderStatusList = await AppModule.GetOrderStatusList()
  }

  @Watch('orderList')
  private onOrderListChange () {
    this.WithdrawList = this.orderList
  }
  mounted () {
    this.init()
  }
}
